export default "__VITE_ASSET__CPiZAUNQ__"